<template>
  <b-col sm="12" :lg="size" :offset-lg="offset">
    <div class="animated fadeIn">
      <DateModal :modalID="typeParam" :fetchData="fetchData" :dateFrom="dateFrom" :dateTo="dateTo"
        @date-picker-modal-emit="onDatePickerModalEmit"></DateModal>
      <b-card class="backClass">
        <div slot="header" style="display:flex; justify-content: space-between;  align-items: center;">
          <HeaderTitle :title="title" :dateFrom="from ? from : dateFrom" :dateTo="to ? to : dateTo"></HeaderTitle>
          <HeaderControl :showFullscreenIcon="true" :showDateIcon="true" :showDownloadPdfIcon="true"
            @emit-fullscreen="toggleFullScreen" @emit-date="modalDateEvent(typeParam)" @emit-pdf-download="downloadPDF">
          </HeaderControl>
        </div>
        <div class="chart-wrapper">
          <div v-if="loadingData" class="centered_container">
            <LoadingCard></LoadingCard>
          </div>
          <highcharts ref="backRef" v-else :options="chartOptions" class="chart" :constructor-type="'chart'">
          </highcharts>
        </div>
        <div slot="footer">
          <b-button :disabled="!showAll" class="btn-outline" variant="outline-primary" left
            @click="(showAll = false), fetchData()">Top 10
          </b-button>
          <b-button :disabled="showAll" class="btn-outline float-right" variant="outline-primary" right
            @click="(showAll = true), fetchData()">All Data
          </b-button>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import exporting from "highcharts/modules/exporting";
import { chartOptionsFailureMixin } from "./addons/chartOptionsFailureMixin.js";
import { chartFunctionsMixin } from "./addons/chartFunctionsMixin.js";
import LoadingCard from "../shared/LoadingCard.vue";
import HeaderTitle from "../shared/HeaderTitle.vue";
import HeaderControl from "../shared/HeaderControl.vue";
import DateModal from "../shared/DateModal.vue";

exporting(Highcharts);

export default {
  mixins: [chartOptionsFailureMixin, chartFunctionsMixin],
  components: {
    highcharts: Chart,
    Highcharts,
    DateModal,
    LoadingCard,
    HeaderTitle,
    HeaderControl
  },
  props: ["size", "offset", "part", "type", "title"],
  data: function () {
    return {
      partNum: "",
      typeParam: ""
    };
  },
  methods: {
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        fns_part: this.partNum,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo
      };
      this.$http
        .get("api/sercomm/products/getFailureDataBy" + this.typeParam + ".php", {
          params
        })
        .then(
          res => {
            if (!this.showAll) {
              this.chartOptions.series[0].data = res.data.slice(0, 10);
            } else {
              this.chartOptions.series[0].data = res.data;
            }
            this.chartOptions.title.text = "Total units: " + res.data.totals;

            this.loadingData = false;
            setTimeout(() => {
              this.changeHeight();
            });
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
    }
  },
  mounted() {
    this.typeParam = this.type;
    this.partNum = this.part;
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}

.highcharts-exporting-group {
  display: none !important;
}

.centered_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
